<template>
  <div>
    <b-navbar class="navbar position-absolute" toggleable="lg">
      <b-navbar-brand href="/"><img class ="navbar-brand-img" :style="getLogoStyles" :src="getLogo"/></b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <span style="display: contents">
            <b-nav-item><base-button blue @click="() => { $router.push('/inicio-sesion') }"><span>{{ $t('login-wrd') }}</span> <base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" class="ml-2" :color="$uiHelpers.isMobile ? ORANGE_COLOUR : 'white'"/></base-button></b-nav-item>
          </span>             
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <abogality-main-block></abogality-main-block>
    <abogality-cards-slider></abogality-cards-slider>
    <abogality-security-privacity-block></abogality-security-privacity-block>
    <abogality-professional-platform></abogality-professional-platform>
    <abogality-subscriptions></abogality-subscriptions>
    <companies-contact-form :subtitle="$t('abogalitypro.contact-form.text')" :serviceType="$t('legal-services')" forIndividualsOnly showReason showCollegiateNumber :platform="'Openlegal'" productName="Openlegal"></companies-contact-form>
  </div>
</template>

<script>
import AbogalityMainBlock from './AbogalityMainBlock.vue'
import AbogalityCardsSlider from './AbogalityCardsSlider.vue'
import AbogalitySecurityPrivacityBlock from './AbogalitySecurityPrivacityBlock.vue'
import AbogalityProfessionalPlatform from './AbogalityProfessionalPlatform.vue'
import AbogalitySubscriptions from './AbogalitySubscriptions.vue'
import CompaniesContactForm from '@/components/forms/CompaniesContactForm.vue'
import { BNavbar, BNavbarBrand, BNavbarToggle, BCollapse, BNavbarNav, BNavItem } from 'bootstrap-vue'
import layoutMixin from '@/mixins/layout.mixin'
import LangSelector from '@/components/base/LangSelector'
import { ORANGE_COLOUR } from '@/constants/colours'

export default {
  mixins: [layoutMixin],
  data () {
    return {
      ORANGE_COLOUR
    }
  },
  components: {
    AbogalityMainBlock,
    BNavbar,
    BNavbarBrand,
    BNavbarToggle,
    BCollapse,
    BNavbarNav,
    BNavItem,
    AbogalityCardsSlider,
    AbogalitySecurityPrivacityBlock,
    AbogalityProfessionalPlatform,
    AbogalitySubscriptions,
    CompaniesContactForm,
    LangSelector
  }
}
</script>

<style lang="scss">
@import "static-appopensalud/css/public/views/abogalitypro.scss";
/* @import "static-appopensalud/css/public/views/opensalud_empresas.scss"; */

/* .lang-cnt {
  color: $blue !important;

  span.active {
    border-color: $blue !important;
  }
} */

.section h3 {
  color: $black;
}

.subtitle {
  p {
    font-weight: initial;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/views/abogalitypro/Home.vue